// Interfaces
import { IBaseCardProps } from './interfaces'

// Styles
import styles from './index.module.scss'

const BaseCard = ({ alertHeight, alert, children, noPadding, alertHeightAuto, className }: IBaseCardProps) => {
  return (
    <div className={`${styles.card} ${className}`}>
      {alert && (
        <div
          className={`${styles.notification}`}
          style={{
            height: alertHeight ? alertHeight : alertHeightAuto ? 'auto' : '86px',
          }}
        >
          <div className="font-16">{alert}</div>
        </div>
      )}

      <div className={`${styles.container} ${noPadding ? styles['no-padding'] : ''}`}>{children}</div>
    </div>
  )
}

export { BaseCard }
